<script setup>

</script>

<template>
  <div>
    Forgot password
  </div>
</template>